<div class="bg-none flex flex-col w-full mt-[-2.5rem] gap-1">
  <!-- menu section with the search field and display format -->
  <div class="flex flex-col items-center justify-center">
    <div class="flex flex-col w-[96%] bg-white rounded-md border px-3 ml-2 mr-2 shadow-sm">
      

    <div
      class="flex flex-row items-center max-h-[80px]  justify-center w-full"
    >
      <!-- Search + Filter Dropdown -->
      <div class="relative ml-2 w-full max-w-md flex flex-row items-center gap-2">
        <!-- Icon inside input -->
        <span
          class="absolute left-3 ml-2 z-10 top-1/2 -translate-y-1/2 pointer-events-none"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
<path d="M15.5 14.0006H14.71L14.43 13.7306C15.63 12.3306 16.25 10.4206 15.91 8.39063C15.44 5.61063 13.12 3.39063 10.32 3.05063C6.09001 2.53063 2.53002 6.09063 3.05002 10.3206C3.39002 13.1206 5.61002 15.4406 8.39002 15.9106C10.42 16.2506 12.33 15.6306 13.73 14.4306L14 14.7106V15.5006L18.25 19.7506C18.66 20.1606 19.33 20.1606 19.74 19.7506C20.15 19.3406 20.15 18.6706 19.74 18.2606L15.5 14.0006ZM9.50002 14.0006C7.01002 14.0006 5.00002 11.9906 5.00002 9.50063C5.00002 7.01063 7.01002 5.00063 9.50002 5.00063C11.99 5.00063 14 7.01063 14 9.50063C14 11.9906 11.99 14.0006 9.50002 14.0006Z" fill="#00358E"/>
</svg>

        </span>

        <div class="relative flex-1 ml-2">
          <input
            #searchInput
            type="search"
            placeholder="Search Client"
            [ngModel]="searchValue()"
            (ngModelChange)="onSearchChange($event)"
            class="w-full text-[14px] font-normal leading-[20px] h-[40px] pl-8 pr-2 py-2 rounded-md border-solid border-2 shadow-none outline-1"
          />
        </div>

        <!-- Filter Dropdown -->
        <div class="relative inline-block" #filterWrapper>
          <button
            (click)="toggleFilterDropdown()"
            class="ml-2 px-3 py-2 rounded-lg text-gray-700 bg-none focus:outline-none flex items-center gap-2"
          >
            <lucide-angular [img]="ListFilter" size="24"></lucide-angular>
          </button>

          <div
            *ngIf="filterDropdownOpen"
            class="absolute left-0 mt-2 w-[32rem] bg-white border rounded-md shadow-2xl z-50"
          >
            <!-- Filter Modal Header -->
            <div class="border-b flex justify-between items-center border-gray-200 p-3 px-6">
              <h3 class="text-lg font-semibold text-[#00358E]">
                Filter By</h3>

              <img (click)="toggleFilterDropdown()" src="assets/logos/Cross-mark-Client-Nav.svg" alt="Close Icon" class="w-4 h-4 cursor-pointer"/>
            </div>

            <div class="flex h-[320px]">
              @for(filter of filtersConfig(); track filter.key) {
              <div class="flex flex-col w-full pl-[16px]">   

                <div class="w-full p-3 overflow-x-hidden">
                  <p class="font-semibold text-black text-base mb-2">
                    {{ filter.label }}
                  </p>
                  <div class="space-y-1.5 max-h-64 overflow-y-auto pr-2">
                    <label
                      *ngFor="let option of filter.options"
                      class="flex items-center space-x-2.5 cursor-pointer text-xs font-normal leading-[20px] text-black hover:text-gray-800 py-0.5 rounded hover:bg-gray-50"
                    >
                      <input
                        type="{{ filter.type }}"
                        [name]="
                          filter.type === 'radio'
                            ? filter.key
                            : undefined
                        "
                        [checked]="
                          tempFilters()[filter.key]?.includes(option)
                        "
                        (change)="
                          onFilterChange(filter.key, option, $event)
                        "
                        class="rounded border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      />
                      <span>{{ option }}</span>
                    </label>
                  </div>

                </div>
              </div>
            }
            </div>

            <!-- Action Buttons -->

            <!-- Action Buttons -->
            <div
              class="flex justify-end gap-2.5 p-3 border-t border-gray-200 bg-[#00358E] rounded-b-md"
            >
              <button
                (click)="resetFilters()"
                class="px-3 py-1.5 text-sm text-white font-medium rounded-lg tracking-[0.1px] leading-[20px] transition-colors"
              >
                Clear filter
              </button>
              <button
                (click)="applyFilters()"
                class="px-3 mr-2 py-1.5 text-sm font-medium bg-white tracking-[0.1px] leading-[20px] text-[#00358E] rounded-full hover:bg-[#e4e3e3] transition-colors"
              >
                Apply Filter
              </button>
            </div>
          </div>
        </div>
      </div>

      @if (!showActionsScrollControls()) {
      <div class="grow"></div>
      }
      
      @if (showActionsScrollControls()) {
        <button
          type="button"
          class="ml-2 mr-2 flex items-center justify-center h-[40px] w-[40px] rounded-full border border-[#D8D8D8] bg-white text-[#00358E] disabled:opacity-40"
          (click)="scrollActions(-260)"
          [disabled]="!canScrollActionsLeft()"
          aria-label="Scroll actions left"
        >
          <lucide-angular [img]="ChevronLeft" size="18"></lucide-angular>
        </button>
      }

      <div
        #actionsScroll
        class="client-nav-actions-scroll flex items-center gap-0 min-w-0 flex-nowrap"
        [class.flex-1]="showActionsScrollControls()"
        [class.ml-2]="!showActionsScrollControls()"
        (scroll)="onActionsScroll()"
      >
        @if (!isGridView && columnEditTableSignal()) {
          <div class="flex items-center shrink-0 mr-3" [class.ml-2]="!showActionsScrollControls()">
              <column-edit [table]="columnEditTableSignal()!" [config]="columnEditConfig" [openFromButtonEnd]="true" (tablePrefsChange)="onColumnCustomizationChange($event)"></column-edit>
          </div>

        <svg class="mx-4 shrink-0" xmlns="http://www.w3.org/2000/svg" width="1" height="80" viewBox="0 0 1 80" fill="none">
          <rect y="80" width="80" height="1" transform="rotate(-90 0 80)" fill="#D8D8D8"/>
        </svg>
        }

        <!-- List-Grid toggle -->
        <div class="flex items-center gap-2 min-h-full shrink-0">
          <p class="text-[13px] font-normal leading-[18px]">View by</p>
          <div class="flex items-center ">
            <button (click)="switchView(false)" [class]="(isGridView ? 'bg-white text-[#1B64BD]' : 'bg-[#2A7DE1] text-white') + ' p-3 list-view-button border border-[#2A7DE1] border-solid font-medium leading-[24px] tracking-[0.4px]'">List</button>
            <button (click)="switchView(true)" [class]="(isGridView ? 'bg-[#2A7DE1] text-white' : 'bg-white text-[#1B64BD]') + ' p-3 grid-view-button border border-[#2A7DE1] border-solid font-medium leading-[24px] tracking-[0.4px]'">Grid</button>
          </div>
        </div>

        <svg class="mx-4 shrink-0" xmlns="http://www.w3.org/2000/svg" width="1" height="80" viewBox="0 0 1 80" fill="none">
          <rect y="80" width="80" height="1" transform="rotate(-90 0 80)" fill="#D8D8D8"/>
        </svg>

        <!-- Sort by button  -->
        <div class="flex items-center gap-2 mr-4 cursor-pointer hover:bg-[#e4e3e3] shrink-0" (click)="toggleSortBy()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect x="2" y="2" width="20" height="20" rx="3" fill="#2A7DE1"/>
            <path d="M6 18H9C9.55 18 10 17.55 10 17C10 16.45 9.55 16 9 16H6C5.45 16 5 16.45 5 17C5 17.55 5.45 18 6 18ZM5 7C5 7.55 5.45 8 6 8H18C18.55 8 19 7.55 19 7C19 6.45 18.55 6 18 6H6C5.45 6 5 6.45 5 7ZM6 13H14C14.55 13 15 12.55 15 12C15 11.45 14.55 11 14 11H6C5.45 11 5 11.45 5 12C5 12.55 5.45 13 6 13Z" fill="white"/>
          </svg>

          <div>
            <p class="text-[13px] font-normal leading-[18px]">Sort by</p>
            <p class="font-medium text-[16px] leading-[22px]">{{sortBy === 'new' ? 'Newest' : 'Oldest'}}</p>
          </div>

          <lucide-angular class="text-[#00358E] ml-1" [img]="ChevronDown" size="20"></lucide-angular>
        </div>

        <!-- Export Data Button -->
        <button
          (click)="exportClientsData()"
          [disabled]="isExporting || filteredClients().length === 0"
          class="px-6 py-3 mr-4 h-[40px] min-h-[40px] max-h-[40px] rounded-full bg-white border text-[14px] font-medium border-[#00358E] text-[#00358E] flex items-center gap-2 transition-colors disabled:opacity-60 disabled:cursor-not-allowed shrink-0
                 {{
            isExporting ? 'bfg-[#fff]' : 'bg-[#fff] hover:bg-[#e4e3e3]'
          }}"
        >
          <ng-container *ngIf="!isExporting; else exportingTpl"
            >
            <lucide-angular [img]="Download" size="16" />
            Export Data</ng-container
          >
          <ng-template #exportingTpl>
            <span class="flex items-center gap-2">
              <span
                class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
              ></span>
              Exporting...
            </span>
          </ng-template>
        </button>

        <!-- New Client Button -->
        <button
          (click)="openNewClientModal()"
          class="px-6 py-3 mr-2 rounded-[44px] h-[40px] min-h-[40px] max-h-[40px] text-white font-medium leading-[20px] tracking-[0.1px] flex items-center gap-2 bg-[#00358E] hover:bg-[#002766] transition-colors shrink-0"
          aria-label="Create New Client"
        >
          <lucide-angular [img]="Plus" size="16" />
          Add New Client
        </button>
      </div>

      @if (showActionsScrollControls()) {
        <button
          type="button"
          class="ml-2 flex items-center justify-center h-[40px] w-[40px] rounded-full border border-[#D8D8D8] bg-white text-[#00358E] disabled:opacity-40"
          (click)="scrollActions(260)"
          [disabled]="!canScrollActionsRight()"
          aria-label="Scroll actions right"
        >
          <lucide-angular [img]="ChevronRight" size="18"></lucide-angular>
        </button>
      }

      <!-- View Toggle Buttons -->
      <!-- <div
        class="relative flex items-center rounded-full border outline-1 h-8 bg-gray-100 px-1 gap-1"
      > -->
        <!-- Sliding indicator -->
        <!-- <div
          class="absolute top-1/2 left-1 transition-transform duration-300 h-6 w-6 bg-blue-100 rounded-full z-0 -translate-y-1/2"
          [ngStyle]="{
            transform: isGridView
              ? 'translateY(-50%) translateX(0)'
              : 'translateY(-50%) translateX(28px)'
          }"
        ></div> -->
        <!-- Grid Button -->
        <!-- <button
          [class.text-blue-700]="isGridView"
          (click)="switchView(true)"
          class="relative z-10 flex items-center justify-center rounded-full w-6 h-6 focus:outline-none transition-colors duration-300"
          aria-label="Grid View"
        >
          <lucide-angular [img]="LayoutGrid" size="16" />
        </button> -->
        <!-- List Button -->
        <!-- <button
          [class.text-blue-700]="!isGridView"
          (click)="switchView(false)"
          class="relative z-10 flex items-center justify-center rounded-full w-6 h-6 focus:outline-none transition-colors duration-300"
          aria-label="List View"
        >
          <lucide-angular [img]="List" size="16" />
        </button>
      </div> -->
      
    </div>
      <div
      class="w-full flex flex-wrap pl-5 mb-2 gap-2"
      *ngIf="activeFilters().length > 0"
    >
      <ng-container *ngFor="let filter of activeFilters()">
        <ng-container *ngFor="let value of filter.values">
          <span
            class="px-3 py-2 gap-2 border border-solid border-[#757575] inline-flex items-center justify-center rounded-full"
          >
            {{ value }}
            <button
              type="button"
              class="font-medium text-black text-[14px] p-[5px] leading-[20px] tracking-[0.1px] cursor-pointer"
              [attr.data-filter-key]="filter.key"
              [attr.data-filter-value]="value"
              (mouseup)="handleRemoveFilter($event)"
            >
              ✕
            </button>
          </span>
        </ng-container>
      </ng-container>

    </div>

      </div>
  </div>

 <div class="min-h-[600px] relative">
    <!-- Loading overlay for page transitions -->
    @if (isPageLoading()) {
      <div class="absolute inset-0 bg-white/80 backdrop-blur-[2px] z-10 flex flex-col items-center justify-center gap-4 transition-opacity duration-200">
        <div class="flex flex-col items-center gap-4">
          <!-- Animated dots -->
          <div class="flex items-center gap-2">
            <span class="w-3 h-3 rounded-full bg-[#00358E] animate-bounce" style="animation-delay: 0ms"></span>
            <span class="w-3 h-3 rounded-full bg-[#2A7DE1] animate-bounce" style="animation-delay: 150ms"></span>
            <span class="w-3 h-3 rounded-full bg-[#FFBE00] animate-bounce" style="animation-delay: 300ms"></span>
          </div>
          <span class="text-sm font-medium text-[#00358E] tracking-wide">Loading records...</span>
        </div>
      </div>
    }
       @if (isGridView) {
    <div class="relative flex flex-col min-h-[600px]" [@viewSwitch]>
      <div class="flex-1">
        <div class="w-full mt-1">
        <div class="flex bg-[#FAFAFA] px-4 py-2 mt-4 w-full">
          <div class="flex justify-center w-full">
            <div
              class="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 w-full max-w-[90%] lg:max-w-[85%] xl:max-w-[80%]"
            >
              @for (client of gridPaginatedClients(); track client.id) {
            <div
              (click)="openClientDashboard(client.clientName, client.id)"
              class="bg-white rounded-sm border border-radius-[8px] border-gray-300 shadow-md flex flex-col hover:shadow-lg transition-shadow cursor-pointer w-full max-w-[300px] mx-auto min-h-[200px]"
            >
              <!-- Header with client name -->
              <div
                class="min-h-[35px] mr-6 mb-4 ml-6 mt-6 border-radius:[8px] border-gray-300 flex items-center"
              >
                <span class="font-bold text-[#2A7DE1] text-sm flex-1 truncate" [attr.title]="client.clientName">{{
                  client.clientName
                }}</span>
               
              </div>

              <!-- Logo- state and name section -->
              <div
                class="flex flex-col gap-2 mr-6 ml-6 flex-shrink-0 text-sm"
              >
                <div class="flex gap-1">
                  <img
                    src="assets/logos/location_city.svg"
                    loading="lazy"
                    alt="Client Logo"
                    class="w-5 h-5"
                  />
                  <p class="truncate" [attr.title]="client.state">{{client.state}}</p>
                </div>
                <div class="flex items-center gap-1 text-sm">
                  <img
                    src="assets/logos/client-person-icon.svg"
                    loading="lazy"
                    alt="Client Logo"
                    class="w-5 h-5"
                  />
                  <p class="truncate" [attr.title]="client.salesOwner">{{client.salesOwner}}</p>
                </div>
              </div>

              <!-- Products table section -->
              <div class="w-full mt-6 border-t border-gray-300">
                <div class="grid grid-cols-2 border-b border-gray-300">
                  <div class="py-[3px] font-normal text-xs mt-1 mb-2 ml-6 text-black ">Products</div>
                  <div class="py-[3px] font-normal text-xs mt-1 mb-2 ml-6 text-black">Status</div>
                </div>
                @for (product of getClientProducts(client); track product.name) {
                  <div class="grid grid-cols-2 border-b border-gray-300">
                    <div class="py-2 px-6 text-xs font-medium text-black border-r truncate border-gray-300" [attr.title]="product.name">
                      {{ product.name }}
                    </div>
                    <div class="py-2 px-6 text-xs font-medium truncate text-black" [attr.title]="product.status">
                      {{ product.status }}
                    </div>
                  </div>
                }
                @if (getClientProducts(client).length === 0) {
                  <div class="py-4 text-center text-xs text-gray-400 col-span-2">No products</div>
                }
              </div>
            </div>
            }
            </div>
          </div>
        </div>
        </div>
      </div>
      
    </div>
    } @else {
    <div class="relative w-full" [@viewSwitch]>
      <div class="mt-4">
        <div class="relative w-full pb-4 px-8">
          <verisk-table-component
            class="client-nav-table"
            [rowData]="filteredClients"
            [colData]="colRender"
            [customGlobalFilter]="customGlobalFilter"
            [simplePagination]="false"
            [columnEditConfig]="columnEditConfig"
            (tableSignalReady)="onTableSignalReady($event)"
            (columnsReady)="applyColumnPreferencesToTable()"
            (sortingChange)="onColumnSortChange($event)"
            [tableOptions]="{
                                enableRowSelection: false,
                                enableMultiRowSelection: true,
                                initialPageSize: 10,
                                showActionMenu: false,
                                showTableMenu: false,
                                enableColumnPinning: true,
                                enableDebug: false,
                                debugTable: false,
                                enableColumnResizing: true,
                                enableSorting: true,
                                enableCellEditing: false,
                                enablePagination: false,
                                enableCustomColPinning: 'name',
                                enableCustomGlobalFilter: true,
                                autoResetPageIndex: true,
                                customStyles: {
                                  headerBg: 'rgba(44, 44, 44, 0.87)',
                                  headerTextColor: '#fff',
                                  headerFontSize: '12px',
                                  headerFontWeight: '500',
                                  headerHeight: '52px',
                                  headerPadding: '12px',
                                  cellPadding: '12px',
                                  cellTextAlign: 'left',
                                },
                            }"
            (cellChange)="onCellChange($event)"
          >
          </verisk-table-component>
        </div>
      </div>
    </div>
    }

    <!-- Shared server-side pagination for both views -->
    @if (gridCurrentPage() > 1 || hasNextPage()) {
      <div class="flex items-center justify-end gap-4 px-2 py-2">
        <nav class="flex items-center gap-2 justify-end">
          <ul class="flex items-center gap-2 list-none p-0 m-0">
            <li>
              <button
                class="text-sm px-2 py-1 disabled:opacity-40 text-[#00358E] flex font-medium leading-[18px] items-center gap-1"
                [class.text-gray-400]="gridCurrentPageClamped() <= 1"
                [disabled]="gridCurrentPageClamped() <= 1"
                (click)="gridGoToPage(gridCurrentPageClamped() - 1)"
                aria-label="Previous page"
              >
                <lucide-angular [img]="ChevronLeft" size="16" />
                <span>Previous</span>
              </button>
            </li>

            @for (p of gridPageNumbers(); track p) {
              <li>
                <button
                  class="text-sm px-2 text-[#00358E] font-medium leading-[18px] pb-[2px] pt-1 bg-transparent relative"
                  [class.text-black]="p === gridCurrentPageClamped()"
                  (click)="gridGoToPage(p)"
                  aria-label="Go to page {{p}}"
                >
                  {{ p }}
                  @if (p === gridCurrentPageClamped()) {
                    <div class="absolute bottom-0 left-[2px] w-4/5 h-[3px] bg-[#FFBE00] rounded-[2px]"></div>
                  }
                </button>
              </li>
            }

            <li>
              <button
                class="text-sm px-2 py-1 disabled:opacity-40 text-[#00358E] font-medium leading-[18px] flex items-center gap-1"
                [disabled]="!hasNextPage()"
                (click)="gridGoToPage(gridCurrentPageClamped() + 1)"
                aria-label="Next page"
              >
                <span>Next</span>
                <lucide-angular [img]="ChevronRight" size="16" />
              </button>
            </li>
          </ul>
        </nav>
      </div>
    }
  </div>
</div>

<!-- New Client Modal -->
<div *ngIf="newClientModalOpen" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
  <div class="bg-white rounded-[8px] shadow-2xl w-[600px] max-w-[90%] h-auto p-6 pb-0 relative">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-xl font-medium text-[#00358E]">Add New Client</h2>
      <img src="assets/logos/clientmodal-close-icon.svg" class="cursor-pointer w-[14px] h-[14px]" (click)="closeNewClientModal()" alt="Close">
    </div>

    <form (submit)="$event.preventDefault(); createClient();" class="space-y-4 pb-[88px]">
      <!-- Client Name Field -->
      <div class="relative">
        <input
          #clientNameInput
          id="newClientNameInput"
          type="text"
          [(ngModel)]="newClientName"
          name="newClientName"
          class="w-full border rounded-s-sm px-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          (focus)="onClientNameFocus()"
          (blur)="onClientNameBlur()"
          autocomplete="off"
          maxlength="120"
        />
        <label
          for="newClientNameInput"
          class="absolute left-3 cursor-text transition-all duration-200 px-1"
          (click)="focusClientName()"
          [ngClass]="{
            '-top-2 text-xs text-blue-600 bg-white shadow-sm': clientNameLabelFloating,
            'top-3 text-sm text-gray-500 bg-transparent': !clientNameLabelFloating
          }"
        >
          Client Name
        </label>
      </div>

      <!-- Products Multi-Select -->
      <div>
        <div class="relative" #productDropdownWrapper>
          <input
            #productInput
            id="newClientProductsInput"
            type="text"
            [value]="productSearchTerm"
            (input)="onNewClientProductSearch($any($event.target).value)"
            (focus)="onProductInputFocus()"
            (blur)="onProductInputBlur()"
            placeholder=""
            class="w-full border rounded-md pr-9 px-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            autocomplete="off"
          />
          <label
            for="newClientProductsInput"
            class="absolute left-3 cursor-text transition-all duration-200 px-1"
            (click)="focusProductInput()"
            [ngClass]="{
              '-top-2 text-xs text-blue-600 bg-white shadow-sm': productLabelFloating,
              'top-3 text-sm text-gray-500 bg-transparent': !productLabelFloating
            }"
          >
            Search & Add Products
          </label>
          <button type="button"
            (click)="toggleProductDropdown()"
            class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-300"
            aria-label="Toggle products dropdown">
            <img src="assets/logos/modal-search-icon.svg" class="w-4 h-4" alt="Search" />
          </button>
          <!-- Dropdown list -->
          <div *ngIf="productDropdownOpen" class="absolute z-10 mt-1 w-full bg-white border rounded-md shadow-md max-h-48 overflow-auto flex flex-col gap-1">
            <div *ngIf="filteredNewClientProducts.length === 0" class="p-2 text-xs text-gray-500">No matching products</div>
            <button
              type="button"
              *ngFor="let p of filteredNewClientProducts"
              (click)="$event.stopPropagation(); addNewClientProduct(p)"
              class="w-full px-3 py-2 text-xs hover:bg-blue-50 flex items-center justify-between"
            >
              <span>{{ p }}</span>
              <lucide-angular [img]="Plus" size="14" class="text-blue-500" />
            </button>
          </div>
        </div>
        <div class="flex flex-wrap gap-2 mt-2" *ngIf="newClientProducts.length > 0">
          <span *ngFor="let p of newClientProducts; let i = index" class="flex items-center bg-[#2A7DE1] text-white text-sm font-medium px-6 py-2 rounded-full border border-blue-200">
            {{ p }}
            <button type="button" (click)="removeNewClientProduct(i)" class="text-blue-700 hover:text-red-600 ml-2 font-bold">✕</button>
          </span>
        </div>
      </div>

      <!-- Error / Validation Messages -->
      <div *ngIf="creationError" class="text-sm text-red-600">{{ creationError }}</div>
      <!--<div *ngIf="!creationError && !canCreateClient()" class="text-xs text-gray-500">Client name and at least one product are required.</div>-->

      <!-- Actions -->
      <div class="absolute bottom-0 left-0 right-0 h-[72px] flex justify-end gap-8 bg-[#00358E] px-6 rounded-b-[8px]">
        <button type="button" (click)="closeNewClientModal()" class="text-base text-white hover:text-gray-200" [disabled]="isCreatingClient">Cancel</button>
        <button type="submit" [disabled]="!canCreateClient()" class="py-3 px-6 my-4 text-sm rounded-[44px] font-medium text-[#00358E] bg-white disabled:opacity-60  hover:bg-gray-200 disabled:cursor-not-allowed {{isCreatingClient ? 'bg-green-400' : 'bg-white'}}">
          <ng-container *ngIf="!isCreatingClient; else creatingSpinner">Add Client</ng-container>
          <ng-template #creatingSpinner>
            <span class="flex items-center gap-2">
              <span class="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              Creating...
            </span>
          </ng-template>
        </button>
      </div>
    </form>
  </div>
</div>
